var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbDownIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3378_3300",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0869141,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3378_3300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 3.08691H17V16.0869L10 23.0869L8.75 21.8369C8.63333 21.7202 8.5375 21.5619 8.4625 21.3619C8.3875 21.1619 8.35 20.9702 8.35 20.7869V20.4369L9.45 16.0869H3C2.46667 16.0869 2 15.8869 1.6 15.4869C1.2 15.0869 1 14.6202 1 14.0869V12.0869C1 11.9702 1.01667 11.8452 1.05 11.7119C1.08333 11.5786 1.11667 11.4536 1.15 11.3369L4.15 4.28691C4.3 3.95358 4.55 3.67025 4.9 3.43691C5.25 3.20358 5.61667 3.08691 6 3.08691ZM15 5.08691H6L3 12.0869V14.0869H12L10.65 19.5869L15 15.2369V5.08691ZM17 16.0869V14.0869H20V5.08691H17V3.08691H22V16.0869H17Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownIcon);
export default __webpack_public_path__ + "static/media/thumb-down-icon.cb7e2ce974cd104d1925543e7f8329e2.svg";
export { ForwardRef as ReactComponent };